export default __webpack_public_path__ + "static/media/loginBg2.3adbea12.png";